import { createTelemetryAPI } from '~/utils/telemetry'

export const reportsTelemetry = createTelemetryAPI(({ track }) => ({
  createReport(
    reportName: string,
    orgId: string,
    clusterId: string,
    params: any
  ) {
    return track(`${reportName}: Create Report`, {
      orgId,
      clusterId,
      params
    })
  },
  viewReport(
    reportName: string,
    msg: { orgId: string; clusterId: string; reportId: string }
  ) {
    return track(`${reportName}: View Report`, msg)
  },
  deleteReport(
    reportName: string,
    msg: { orgId: string; clusterId: string; reportId: string }
  ) {
    return track(`${reportName}: Delete Report`, msg)
  }
}))
